export type TenantResolutionErrorCode =
  | 'MALFORMED_HOST'
  | 'UNKNOWN_HOST'
  | 'PENDING_HOST'
  | 'SUSPENDED_HOST'
  | 'DISABLED_HOST'
  | 'INVALID_TENANT_ID'
  | 'LOCAL_OVERRIDE_NOT_ALLOWED'
  | 'MISSING_TENANT'
  | 'INVALID_HOST_RECORD';

export class TenantResolutionError extends Error {
  constructor(
    public readonly code: TenantResolutionErrorCode,
    message: string
  ) {
    super(message);
    this.name = 'TenantResolutionError';
    Object.setPrototypeOf(this, TenantResolutionError.prototype);
  }
}

export const asTenantResolutionError = (error: unknown): TenantResolutionError => {
  if (error instanceof TenantResolutionError) {
    return error;
  }
  return new TenantResolutionError('MISSING_TENANT', 'Unable to resolve the current tenant.');
};
